import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import './Announcements.scss';
import { getLocalCountryLanguage, isEProcurementApp } from '../../../utils/utils';

const AnnouncementBanner = ({ announcementData, index }) => {
  const [value, setValue] = useState({});
  const [iconLink, setIconLink] = useState({});
  const [announcementClose, setAnnouncementClose] = React.useState(false);
  const [
    announcementClosedByUserForCurrentSession,
    setAnnouncementClosedByUserForCurrentSession,
  ] = React.useState(sessionStorage.getItem(`announcementClose ${index}`));
  const [isForECom, setIsForECom] = React.useState();
  const [isForEProc, setIsForEProc] = React.useState();
  const [includedCountries, setIncludedCountries] = React.useState();
  const [excludedCountries, setExcludedCountries] = React.useState();

  const trimCountriesArray = countryArray => countryArray?.map(country => country?.trim());

  const closeAnnouncementBtn = {
    style: { cursor: 'pointer' },
    onClick: () => {
      setAnnouncementClose(true);
      setAnnouncementClosedByUserForCurrentSession(true);
      sessionStorage.setItem(`announcementClose ${index}`, index);
    },
  };

  const isAnnouncementClosed = () => announcementClose || announcementClosedByUserForCurrentSession;

  React.useEffect(() => {
    setValue(announcementData?.properties?.elements?.description?.value);
    setIconLink(announcementData?.properties?.elements?.icon?.value);
    setIsForECom(announcementData?.properties?.elements?.ecomm?.value);
    setIsForEProc(announcementData?.properties?.elements?.eproc?.value);
    setIncludedCountries(
      announcementData?.properties?.elements?.includedCountries?.value?.split(',')
    );
    setExcludedCountries(
      announcementData?.properties?.elements?.excludedCountries?.value?.split(',')
    );
  }, [announcementClose]);

  const shouldAnnouncementShowForCurrCountry = () => {
    const { localeCountry } = getLocalCountryLanguage();
    let showBanner = false;
    const includedArr = trimCountriesArray(includedCountries);
    const excludedArr = trimCountriesArray(excludedCountries);
    if (!includedArr && !excludedArr) {
      // show banner for all countries
      showBanner = true;
    } else if (includedArr?.includes(localeCountry.toUpperCase())) {
      // show for only these countries
      showBanner = true;
    } else if (excludedArr?.includes(localeCountry.toUpperCase())) {
      // will show if not in excluded countries
      return showBanner;
    }
    return showBanner;
  };

  const bannerText = () => ReactHtmlParser(value);
  const commonConditions =
    !isEmpty(value) && !isAnnouncementClosed() && shouldAnnouncementShowForCurrCountry();
  const isEComApp = !isEProcurementApp();
  const displayBanner = commonConditions && (
    <div
      className="announcement-wrapper"
      id="announcement banner"
      data-locator="announcement-component"
      key={index}
    >
      <ReactSVG className="announcement-svg" src={iconLink} />
      {bannerText()}
      <div data-locator="announcement-svg-close" {...closeAnnouncementBtn}>
        <ReactSVG
          className="announcement-svg"
          src="/content/dam/waters/en/brand-assets/icons/close.svg"
        />
      </div>
    </div>
  );
  const displayBannerEcom = isEComApp && isForECom;
  const displayBannerEproc = !isEComApp && isForEProc;
  return (
    <>
      {displayBannerEcom && displayBanner}
      {displayBannerEproc && displayBanner}
    </>
  );
};

AnnouncementBanner.propTypes = {
  announcementData: PropTypes.objectOf(PropTypes.string),
  index: PropTypes.number,
};
AnnouncementBanner.defaultProps = {
  announcementData: {},
  index: 0,
};

export default AnnouncementBanner;
